// Function loadSourcingGuideItemBlock loads the sourcingGuideItemBlock class by dynamically importing the js on demand if needed

export function loadSourcingGuideItemBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-sourcing-guide-item-block-chunk" */ '../widgets/sourcingGuideItemBlock').then(wg => {

		const { SourcingGuideItemBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="SourcingGuideItemBlock"]');

		if(!$wg) {
			// console.info('SourcingGuideItemBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="SourcingGuideItemBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new SourcingGuideItemBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new SourcingGuideItemBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the SourcingGuideItemBlock widget');

}
